import Constants from "./Constants";

export default function getLanguageOptions(strings) {
  return [
    { key: Constants.PT_LANG_KEY, flag: "br", label: strings.PORTUGUESE },
    { key: Constants.EN_LANG_KEY, flag: "us", label: strings.ENGLISH },
    { key: Constants.ES_LANG_KEY, flag: "es", label: strings.SPANISH }
  ];
}
